import React, { useState } from 'react';
import './PricingForm.css';

const PricingForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Send email to info@marsheventsandtraininghub.com
        const mailtoLink = `mailto:info@marsheventsandtraininghub.com?subject=${encodeURIComponent('Request For Pricing')}&body=${encodeURIComponent(
            `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message || 'No message provided'}`
        )}`;
        window.location.href = mailtoLink;
        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            message: ''
        });
    };

    return (
        <div className="pricing-form-widget">
            <h3>Request For Pricing</h3>
            <form onSubmit={handleSubmit} className="pricing-form">
                <div className="form-group">
                    <input
                        type="text"
                        name="name"
                        placeholder="Name*"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email*"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <textarea
                        name="message"
                        placeholder="Message(Optional)"
                        value={formData.message}
                        onChange={handleChange}
                        rows="4"
                    />
                </div>
                <p className="form-disclaimer">
                    By submitting your details you agree to be contacted in order to respond to your enquiry.
                </p>
                <button type="submit" className="pricing-cta-btn">
                    Get up to 40% OFF
                </button>
            </form>
        </div>
    );
};

export default PricingForm;
